import React, { useState, useEffect } from 'react';
import axios from "axios"

function Createrasmal() {

    const [name, setname] = useState("");
    const [total, settotal] = useState("");
    const [tebini, settebini] = useState("");
    const [date, setDate] = useState("");
    const [qarz, setqarz] = useState("");



    const createCustomer = async () => {
        axios.post("https://car-api.redcode.app/coc/createqarz/", {
            name: name,
            total: total,
            tebini: tebini,
            qarz: qarz,
            date: date,
        }).then((res) => {
            window.location.reload(false)
            alert(" دروست کرا")

        })


        // console.log(fullname)
        // console.log(company)
        // console.log(phonenum)
        // console.log(email)
        // console.log(address)
        // console.log(date)

    }

    const [option, setOptions] = useState([]);


    useEffect(() => {
        axios.get("https://car-api.redcode.app/customer/getoptions/").then((response) => {
            setOptions(response.data)
            // setCustomid(props.asman)
        });
    }, []);



    return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: "20px" }}>
            <div className="col-md-10 col-lg-10" dir="rtl">
                <h4 className="mb-3">رَسْمال زیاد بکە</h4>
                <div style={{ display: "flex", flexDirection: "row" }}>



                    <td>
                        <select name="car" onChange={e => setqarz(e.target.value)} >
                            <option value="">جۆری قەرز</option>
                            {option.filter(e => e.OPkey === 8).map((e) => {
                                return <option value={e.ID}>{e.OPvalue}</option>
                            })}
                        </select>
                    </td>


                </div>
                <form className="needs-validation" >
                    <div className="row g-3">

                        <div className="col-sm-6">
                            <label htmlFor="firstName" className="form-label">ناو</label>
                            <input onChange={e => setname(e.target.value)} type="text" className="form-control" id="firstName" placeholder="" />
                        </div>


                        <div className="col-md-6">
                            <label htmlFor="cc-number" className="form-label">بڕی دۆلار </label>
                            <input onChange={e => settotal(e.target.value)} type="number" className="form-control" id="cc-number" placeholder="" />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="email" className="form-label">تێبینی</label>
                            {/* <span className="text-muted">(اختياري)</span> */}
                            <textarea onChange={e => settebini(e.target.value)} className="form-control" id="email" />
                        </div>

                        <div className="col-md-6">
                            <label htmlFor="address" className="form-label">کات</label>
                            <input type="date" onChange={e => setDate(e.target.value)} className="form-control" id="address" placeholder="" />

                        </div>

                        <button className="w-100 btn btn-dark btn-lg" onClick={createCustomer} type="button">رَسْمال زیاد بکە</button>


                        <hr className="my-4" />
                    </div>
                </form>

            </div>
        </div>
    )
}

export default Createrasmal
